export const SM = 'sm'
export const MD = 'md'
export const LG = 'lg'

export const ACCEPTED_DIMENSIONS = [SM, MD, LG]
